import React, { useEffect} from "react";
import { Label, Button } from "./styles";

const InputCheck = ({
  text,
  name,
  id,
  value,
  checked,
  alterColor = false,
  disabled = false,
  onClick = () => {},
  onChange = () => {},
  ...rest
}) => {

  useEffect(() => {
    console.log("checked",checked)
  }, [checked]);

  return (
    <>
      <Button
        htmlFor={id}
        checked={checked}
        onClick={onClick}
        {...rest}
        >
        <input
          type="checkbox"
          name={name}
          id={id}
          onChange={onChange}
          value={value}
          checked={checked}
        />
        <div>{text}</div>
      </Button>
    </>
  );
};

export default InputCheck;
